const mutations = {
    SET_ERROR_BANNERS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
